'use client';

export interface FbCookies {
  _fbp: string | undefined;
  _fbc: string | undefined;
}

function parseCookie(name: string): string | undefined {
  if (typeof document === 'undefined') return undefined;
  const match = document.cookie
    .split(';')
    .map((c) => c.trim())
    .find((c) => c.startsWith(`${name}=`));
  return match ? decodeURIComponent(match.slice(name.length + 1)) : undefined;
}

export function getFbCookies(): FbCookies {
  return {
    _fbp: parseCookie('_fbp'),
    _fbc: parseCookie('_fbc'),
  };
}
